'use strict';

var _regeneratorRuntime = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var CID = require('cids');

var multiaddr = require('multiaddr');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var _require2 = require('./response-types'),
    FinalPeer = _require2.FinalPeer;

module.exports = configure(function (api) {
  return (
    /*#__PURE__*/
    function () {
      var _findPeer = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(peerId) {
        var options,
            res,
            _iteratorNormalCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            _value,
            data,
            _data$Responses$,
            ID,
            Addrs,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return api.post('dht/findpeer', {
                  timeout: options.timeout,
                  signal: options.signal,
                  searchParams: toUrlSearchParams(_objectSpread({
                    arg: "".concat(Buffer.isBuffer(peerId) ? new CID(peerId) : peerId)
                  }, options)),
                  headers: options.headers
                });

              case 3:
                res = _context.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 6;
                _iterator = _asyncIterator(res.ndjson());

              case 8:
                _context.next = 10;
                return _iterator.next();

              case 10:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 14;
                return _step.value;

              case 14:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 23;
                  break;
                }

                data = _value;

                if (!(data.Type === FinalPeer && data.Responses)) {
                  _context.next = 20;
                  break;
                }

                _data$Responses$ = data.Responses[0], ID = _data$Responses$.ID, Addrs = _data$Responses$.Addrs;
                return _context.abrupt("return", {
                  id: ID,
                  addrs: (Addrs || []).map(function (a) {
                    return multiaddr(a);
                  })
                });

              case 20:
                _iteratorNormalCompletion = true;
                _context.next = 8;
                break;

              case 23:
                _context.next = 29;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](6);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 29:
                _context.prev = 29;
                _context.prev = 30;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 34;
                  break;
                }

                _context.next = 34;
                return _iterator.return();

              case 34:
                _context.prev = 34;

                if (!_didIteratorError) {
                  _context.next = 37;
                  break;
                }

                throw _iteratorError;

              case 37:
                return _context.finish(34);

              case 38:
                return _context.finish(29);

              case 39:
                throw new Error('not found');

              case 40:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 25, 29, 39], [30,, 34, 38]]);
      }));

      function findPeer(_x) {
        return _findPeer.apply(this, arguments);
      }

      return findPeer;
    }()
  );
});